import React from 'react';
import { deleteAccount } from '../../../actions/account-api';
import * as R from 'ramda';
import { useDispatch, useSelector } from 'react-redux';
import * as Text from '../../../constants/translations/account';
import { getAuthenticationUrl } from '../../../constants/webapi/account';
import { EndPoints } from '../../../constants/api-config';
import * as Loadings from '../../../constants/loadings/account';


export const DeleteModal = () => {
    const accountState = useSelector(state => state.account);
    const dispatch = useDispatch();

    const handleDeleteUser = async (event) => {
        event.preventDefault();
        await dispatch(deleteAccount());
        sessionStorage.removeItem("id_token");
        sessionStorage.removeItem("access_token");
        window.location = "https://" + (EndPoints.environment === "production" ? "accounts" : "accounts-dev") + ".securibox.eu/id/connect/endsession";
    };

    return (
        <div className="modal" id="accountRemove" tabIndex={-1} aria-labelledby="accountRemoveLabel" aria-hidden="true">
            <div className="modal-dialog modal-sm">
                <div className="modal-content shadow-lg rounded-sm">
                    <div className="modal-header">
                        <h5 className="modal-title small h6" id="accountRemoveLabel">{Text.SadLeaving[accountState.user.language]}</h5>
                        <button type="button" className="btn-close fw-light shadow-none" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true" className="sr-only">Close</span>
                        </button>
                    </div>
                    <div className="modal-body">
                        <div className="py-3 pt-lg-5 text-center">
                            <i className="mdi mdi-trash-can-outline display-2 lh-1 text-danger"></i>
                            <h5 className="heading h4 mt-4">{Text.DeleteAccount[accountState.user.language]}</h5>
                            <p className="o-80">{Text.DeleteWarning[accountState.user.language]}</p>
                        </div>
                    </div>
                    <div className="modal-footer justify-content-center">
                        <button type="button" disabled={accountState.isLoading.includes(Loadings.DELETING_ACCOUNT)} className="btn btn-delete px-g1 flex-row align-items-center gap-2" onClick={(event) => { handleDeleteUser(event); }}>
                            {Text.DeleteConfirm[accountState.user.language]}
                            {accountState.isLoading.includes(Loadings.DELETING_ACCOUNT) ?
                                <div className="spinner-border spinner-border-sm text-delete" role="status">
                                    <span className="sr-only">Loading...</span>
                                </div>
                                : null
                            }
                        </button>
                        <button type="button" className="btn btn-dim" data-dismiss="modal">{Text.Cancel[accountState.user.language]}</button>
                    </div>
                </div>
            </div>
        </div>
    );
};